import { render, staticRenderFns } from "./MobileSearchSuggestion.vue?vue&type=template&id=ce7927fc&scoped=true"
import script from "./MobileSearchSuggestion.vue?vue&type=script&lang=js"
export * from "./MobileSearchSuggestion.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ce7927fc",
  null
  
)

export default component.exports